/* __next_internal_client_entry_do_not_use__ default auto */import { jsx as _jsx } from "react/jsx-runtime";
// import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
export default function GlobalError(param) {
  let {
    error
  } = param;
  // useEffect(() => {
  //   Sentry.captureException(error);
  // }, [error]);
  return /*#__PURE__*/_jsx("html", {
    children: /*#__PURE__*/_jsx("body", {
      children: /*#__PURE__*/_jsx(NextError, {
        statusCode: 0
      })
    })
  });
}